import React from "react";
import styled from "styled-components";
import Arrow from "./Arrow";
import { scrollToApply } from "./anchors";

/**
 * The pill CTA from the reference: h-14, rounded-full, brand red with a red glow.
 * Sentence case (the reference applies uppercase only to the form's submit).
 */
const Wrapper = styled.button`
  appearance: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  padding: 0 32px;
  border: none;
  border-radius: 999px;
  background: var(--brand-red);
  color: #fff;
  font-family: var(--brand-sans);
  font-size: 16px;
  font-weight: 800;
  box-shadow: 0 16px 30px -12px rgba(209, 31, 61, 0.7);
  transition:
    background 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.35s cubic-bezier(0.4, 0, 0.2, 1);

  svg {
    margin-left: 8px;
    width: 20px;
    height: 20px;
    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    background: var(--brand-red-deep);
    box-shadow: 0 20px 36px -12px rgba(155, 18, 40, 0.75);
  }

  &:hover svg {
    transform: translateX(10px);
  }

  &:focus-visible {
    outline: 3px solid var(--brand-red);
    outline-offset: 3px;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

const CtaButton = ({
  children = "Check your approval",
  className,
  showArrow = true,
}: {
  children?: React.ReactNode;
  className?: string;
  /** the v2 closing CTA is label-only */
  showArrow?: boolean;
}) => (
  <Wrapper
    type="button"
    onClick={scrollToApply}
    className={`lp-cta ${className || ""}`}
  >
    {children}
    {showArrow ? <Arrow /> : null}
  </Wrapper>
);

export default CtaButton;
